import React from 'react';

import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { localisedPath } from 'common/url_locale_helper';

export default class AddToCartButton extends React.Component {
  static defaultProps = {
    retailExclusive: false,
  };

  static propTypes = {
    sku: propTypes.string,
    lineItemsPending: propTypes.array.isRequired,
    isSoldOut: propTypes.bool,
    retailExclusive: propTypes.bool,
    isSubscriberExclusive: propTypes.bool,
    isSubscribed: propTypes.bool,
    offeringId: propTypes.number,
  };

  handleAddToCartClick = () => {
    const {
      lineItemsPending,
      offeringId,
      isOpen,
      updateLineItems,
      onClick,
    } = this.props;
    const hasOfferingId = !!offeringId;
    if (hasOfferingId) {
      const item = lineItemsPending.find(
        item => item.offeringId === offeringId
      );
      if (item) {
        item.offeringId = offeringId;
        updateLineItems([item]);
      }
    } else {
      updateLineItems(lineItemsPending);
    }

    if (!isOpen) {
      const shouldAutoClose = hasOfferingId;
      this.props.openCartForDesktop(shouldAutoClose);
    }
    onClick && onClick();
  };

  getDisplayQuantity = (pendingQuantity, pendingQuantities, offeringId) => {
    if (offeringId && pendingQuantities) {
      const lineItem = Array.isArray(pendingQuantities)
        ? pendingQuantities.find(item => item.offeringId === offeringId)
        : pendingQuantities;
      return lineItem ? lineItem.quantity : 0;
    }
    return Array.isArray(pendingQuantities)
      ? pendingQuantities.reduce((total, item) => {
          return total + item.quantity;
        }, 0)
      : pendingQuantity;
  };

  get text() {
    const {
      pendingQuantity,
      pendingQuantities,
      offeringId,
      isSoldOut,
      isSubscriberExclusive,
      isSubscribed,
      text,
    } = this.props;

    const displayQuantity = this.getDisplayQuantity(
      pendingQuantity,
      pendingQuantities,
      offeringId
    );

    let displayText;

    if (text) {
      displayText = text;
    } else if (isSoldOut) {
      displayText = (
        <TranslatedMessage id={'cart.add_to_cart_button.out_of_stock'} />
      );
    } else if (isSubscriberExclusive && !isSubscribed) {
      displayText = (
        <TranslatedMessage
          id={'cart.subscription_commit_button.get_it_with_autoship'}
        />
      );
    } else if (displayQuantity === 0) {
      displayText = (
        <TranslatedMessage id={'cart.add_to_cart_button.add_to_cart'} />
      );
    } else {
      displayText = (
        <TranslatedMessage
          id={'cart.add_to_cart_button.with_quantity'}
          values={{ count: displayQuantity }}
        />
      );
    }

    return displayText;
  }

  redirectToStoreLocator = () => {
    window.location.assign(localisedPath('/locator'));
  };

  render() {
    const {
      isSaving,
      isSoldOut,
      className,
      pendingQuantity,
      pendingQuantities,
      sku,
      variantsSaving,
      retailExclusive,
      offeringId,
    } = this.props;

    const isVariantProcessing = sku
      ? variantsSaving.some(item => {
          return item.sku === sku && item.offeringId === offeringId;
        })
      : isSaving;

    const isDisabled =
      isSoldOut ||
      (this.getDisplayQuantity(
        pendingQuantity,
        pendingQuantities,
        offeringId
      ) <= 0);

    if (retailExclusive) {
      return (
        <Button
          onClick={this.redirectToStoreLocator}
          className={classNames(
            className,
            'AddToCartButton',
            'button--full-width'
          )}
        >
          <TranslatedMessage id={'cart.add_to_cart_button.find_store'} />
        </Button>
      );
    }

    return (
      <Button
        onClick={this.handleAddToCartClick}
        processing={isVariantProcessing}
        disabled={isVariantProcessing || isDisabled || isSoldOut}
        className={classNames(
          className,
          'AddToCartButton',
          'button--full-width'
        )}
      >
        {this.text}
      </Button>
    );
  }
}
